import uploadsaboutsidebyside02imageimg_0052CroppedJpg from "$lib/data/generated/uploads/about/SideBySide 02/image/IMG_0052-cropped.jpg";

export const uploads = {
  "uploads/about/SideBySide 02/image/IMG_0052-cropped.jpg": uploadsaboutsidebyside02imageimg_0052CroppedJpg
};